import React from 'react';
import Contact from '../components/Contact';
import SEOHead from '../components/SEOHead';
import { getSEOConfig } from '../utils/seoConfig';

const ContactPage: React.FC = () => {
  const seoConfig = getSEOConfig('/contact');

  return (
    <>
      <SEOHead
        title={seoConfig.title}
        description={seoConfig.description}
        keywords={seoConfig.keywords}
        ogType={seoConfig.ogType}
      />
      <div style={{ paddingTop: '80px' }}>
        <Contact />
      </div>
    </>
  );
};

export default ContactPage;
